import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { deleteAdmingBillingList } from '~services/admin/billingList';

import { useLazyRequest } from './useLazyRequest';

export const useBillingListAdminDelete = (
  onSuccessDelete?: () => void,
): {
  loading: boolean;
  handleDeleteBillingList: (billingListId: string) => Promise<void>;
} => {
  const { enqueueSnackbar } = useSnackbar();

  const [, loadingDeleteBillingList, , executeDeleteBillingList] =
    useLazyRequest({
      request: deleteAdmingBillingList,
      withPostSuccess: (response) => {
        const currentBillingListData = response.data?.data;

        // eslint-disable-next-line max-len
        const message = `La lista de precios ${currentBillingListData?.billingListCode} fue eliminada correctamente`;

        enqueueSnackbar(message, { variant: 'success' });

        onSuccessDelete?.();
      },
      withPostFailure: () => {
        enqueueSnackbar(
          'No se pudo elimnar la lista de precios, intente nuevamente',
          { variant: 'error' },
        );
      },
    });

  const handleDeleteBillingList = useCallback(
    async (billingListId: string) => {
      await executeDeleteBillingList(billingListId);
    },
    [executeDeleteBillingList],
  );

  return { loading: loadingDeleteBillingList, handleDeleteBillingList };
};
